export { DesktopEducationSection } from './desktop-education-section';
